import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { AgreementsState, AgreementsGroupState } from '../types';

const initialState: AgreementsState = {
  agreements: undefined!,
  agreementsCount: 0,
  showAgreementsMessage: false,
  showAgreementProductSlug: null,
  showAgreementProductClassUuid: null,
};

const agreementsSlice = createSlice({
  name: 'agreements',
  initialState,
  reducers: {
    setAgreementsProcess(state, action: PayloadAction<AgreementsGroupState>) {
      state.agreements = action.payload;
      state.agreementsCount = Object.keys(action.payload).length;
    },

    clearAgreementsProcess(state) {
      state.agreements = initialState.agreements;
    },

    setShowAgreementsMessageProcess(state, action: PayloadAction<boolean>) {
      state.showAgreementsMessage = action.payload;
    },

    setShowAgreementProcess(state, action: PayloadAction<[string | null, string | null]>) {
      const [productSlug, productClassUuid] = action.payload;

      state.showAgreementProductSlug = productSlug;
      state.showAgreementProductClassUuid = productClassUuid;
    },
  },
});

export const {
  setAgreementsProcess,
  clearAgreementsProcess,
  setShowAgreementsMessageProcess,
  setShowAgreementProcess,
} = agreementsSlice.actions;

export const getAgreements = (state: RootState): AgreementsState => state.agreements;

export default agreementsSlice.reducer;
